<template>
	<v-row v-if="!$store.getters.progress" class="ma-0 pb-offset">
		<v-col class="pa-0">
			<v-tabs
				app
				show-arrows
				:height="32"
				class="tabs-route"
				background-color="transparent"
				slider-color="primary">
				<v-tab
					exact-path
					ripple
					key="companies"
					:to="{ path: '/companies/' + id + '/' }">
					{{ $trans('company') }}
				</v-tab>

				<v-tab
					v-if="$store.getters.checkModelPermissions('companydestination')"
					exact-path
					ripple
					key="destinations"
					:to="{ path: '/companies/' + id + '/destinations' }">
					{{ $trans('destinations') }}
				</v-tab>

				<v-tab
					v-if="$store.getters.checkModelPermissions('pricelist')"
					exact-path
					ripple
					key="pricelists"
					:to="{ path: '/companies/' + id + '/pricelists' }">
					{{ $trans('pricelists') }}
				</v-tab>

				<v-tab
					v-if="$store.getters.checkModelPermissions('companycontact')"
					exact-path
					ripple
					key="contacts"
					:to="{ path: '/companies/' + id + '/contacts' }">
					{{ $trans('contacts') }}
				</v-tab>

				<v-tab
					v-if="$store.getters.checkModelPermissions('companydeadline')"
					exact-path
					ripple
					key="deadlines"
					:to="{ path: '/companies/' + id + '/deadlines' }">
					{{ $trans('deadlines') }}
				</v-tab>

				<v-tab
					v-if="$store.getters.checkModelPermissions('companypayment')"
					exact-path
					ripple
					key="payments"
					:to="{ path: '/companies/' + id + '/payments' }">
					{{ $trans('companypayments') }}
				</v-tab>

				<v-tab
					v-if="$store.getters.checkSettings('show_revenue_chart_ddts')
						|| $store.getters.checkSettings('show_sold_products_costs')
						|| $store.getters.checkSettings('show_sold_products_revenue')"
					exact-path
					ripple
					key="analytics"
					:to="{ path: '/companies/' + id + '/analytics' }">
					{{ $trans('analytics') }}
				</v-tab>

				<v-tab
					v-if="$store.getters.checkModelPermissions('opportunity')"
					exact-path
					ripple
					key="opportunities"
					:to="{ path: '/companies/' + id + '/opportunities' }">
					{{ $trans('opportunities') }}
				</v-tab>

				<v-tab
					v-if="$store.getters.checkModelPermissions('quotation')"
					exact-path
					ripple
					key="quotations"
					:to="{ path: '/companies/' + id + '/quotations' }">
					{{ $trans('quotations') }}
				</v-tab>

				<v-tab
					v-if="$store.getters.checkModelPermissions('saleorder')"
					exact-path
					ripple
					key="saleorders"
					:to="{ path: '/companies/' + id + '/saleorders' }">
					{{ $trans('saleorders') }}
				</v-tab>

				<v-tab
					v-if="$store.getters.checkModelPermissions('ddt')"
					exact-path
					ripple
					key="ddts"
					:to="{ path: '/companies/' + id + '/ddts' }">
					{{ $trans('ddts') }}
				</v-tab>

				<v-tab
					v-if="$store.getters.checkModelPermissions('saleinvoice')"
					exact-path
					ripple
					key="saleinvoices"
					:to="{ path: '/companies/' + id + '/invoices' }">
					{{ $trans('saleinvoices') }}
				</v-tab>

				<v-tab
					v-if="$store.getters.checkModelPermissions('creditnote')"
					exact-path
					ripple
					key="creditnotes"
					:to="{ path: '/companies/' + id + '/creditnotes' }">
					{{ $trans('creditnotes') }}
				</v-tab>

				<v-tab
					v-if="$store.getters.checkModelPermissions('subscription')"
					exact-path
					ripple
					key="subscriptions"
					:to="{ path: '/companies/' + id + '/subscriptions' }">
					{{ $trans('subscriptions') }}
				</v-tab>

				<v-tab
					v-if="$store.getters.checkModelPermissions('intent')"
					exact-path
					ripple
					key="intents"
					:to="{ path: '/companies/' + id + '/intents' }">
					{{ $trans('intents') }}
				</v-tab>

				<v-tab
					v-if="$store.getters.checkModelPermissions('project')"
					exact-path
					ripple
					key="projects"
					:to="{ path: '/companies/' + id + '/projects' }">
					{{ $trans('projects') }}
				</v-tab>

				<v-tab
					v-if="$store.getters.checkModelPermissions('asset')"
					exact-path
					ripple
					key="assets"
					:to="{ path: '/companies/' + id + '/assets' }">
					{{ $trans('assets') }}
				</v-tab>

				<v-tab
					v-if="$store.getters.checkModelPermissions('credential')"
					exact-path
					ripple
					key="credentials"
					:to="{ path: '/companies/' + id + '/credentials' }">
					{{ $trans('credentials') }}
				</v-tab>

				<v-tab
					v-if="$store.getters.checkModelPermissions('trouble')"
					exact-path
					ripple
					key="tickets"
					:to="{ path: '/companies/' + id + '/tickets' }">
					{{ $trans('tickets') }}
				</v-tab>

				<v-tab
					v-if="$store.getters.checkModelPermissions('helpdesktrouble')"
					exact-path
					ripple
					key="helpdesk"
					:to="{ path: '/companies/' + id + '/helpdesk' }">
					Service Desk
				</v-tab>
				
				<v-tab 
					v-if="$store.getters.checkModelPermissions('contract')"
					exact-path
					ripple
					key="contracts"
					:to="{ path: '/companies/' + id + '/contracts' }">
					{{ $trans('contracts') }}
				</v-tab>

				<v-tab
					v-else-if="$store.getters.checkModelPermissions('helpdeskcontract')"
					exact-path
					ripple
					key="helpdeskcontracts"
					:to="{ path: '/companies/' + id + '/helpdeskcontracts' }">
					{{ $trans('contracts') }}
				</v-tab>

				<v-tab
					v-if="$store.getters.checkSettings('companies_task')"
					exact-path
					ripple
					key="taskboard"
					:to="{ path: '/companies/' + id + '/taskboard' }">
					{{ $trans('taskboard') }}
				</v-tab>

				<v-tab
					v-if="$store.getters.checkModulePermissions('portal')"
					exact-path
					ripple
					key="portal-users"
					:to="{ path: '/companies/' + id + '/portal-users' }">
					Accessi Cliente
				</v-tab>

				<v-tab
					v-if="$store.getters.checkModulePermissions('portal')"
					exact-path
					ripple
					key="portal-dms"
					:to="{ path: '/companies/' + id + '/portal-dms' }">
					Area Cliente
				</v-tab>
			</v-tabs>

			<v-slide-y-reverse-transition>
				<router-view
					v-show="!$store.getters.progress"
					:key="$route.fullPath"
					:entity-title="entityTitle"
				/>
			</v-slide-y-reverse-transition>
		</v-col>
	</v-row>
</template>

<script>
    import breadcrumbEntityMixin from '@/mixins/breadcrumbEntityMixin'

    export default {
        mixins: [breadcrumbEntityMixin],
        name: 'company-tabs',
        props: {
            id: Number,
        },

        data() {
            return {
                model: {},
            }
        },

        computed: {
            entityTitle()  {
                return this.model.id ? ['code', 'business_name'].reduce((acc, key) => this.model[key] ? acc.concat(this.model[key]) : acc, []).join(' - ') : ''
            }
        },

        created() {
            this.$store.commit('endProgress')
            this.axios.get('companies/' + this.id + '?&lite=1').then(response => {
                this.model = response.data.model
            }, response => {
                // error callback
            })
        },
    }
</script>